export const AddingTenantSchema = {
    tenantFullName: [
        { rule: "required", message: "Full name is required" },
    ],
    tenantEmailId: [
        { rule: "required", message: "Email is required" },
        { rule: "email", message: "Email is invalid" }
    ],
}